// @ts-nocheck

import classNames from 'classnames';
import React, { PureComponent } from 'react';
import { ImageService } from '../../../main/services/ImageService/ImageService';
type Props = {
  size: 'xs' | 'small' | 'medium' | 'large';
  // To center the loader, ensure either a parent div or the className
  // prop passed to the loader has position: relative;
  className?: string;
};
type State = {
  imageLoaded: boolean;
};

class BranchLoader extends PureComponent<Props, State> {
  static defaultProps = {
    size: 'small',
  };

  state = {
    imageLoaded: false,
  };

  _imageHasLoaded = () => {
    this.setState({
      imageLoaded: true,
    });
  };

  render() {
    return (
      <div
        className={`branch-loading-container branch-loading-container__${this.props.size} ${this.props.className}`}
        role="progressbar"
      >
        <div className={`branch-spinner branch-spinner__${this.props.size}`}>
          <div
            className={classNames('branch-spinner__circle', {
              'no-image': !this.state.imageLoaded,
            })}
          />
          <img
            src={ImageService.getImageUrl('/static/images/branch-logos/branch-badge_dark.svg')}
            className={classNames('branch-spinner__branch-mark', {
              hide: !this.state.imageLoaded,
            })}
            onLoad={this._imageHasLoaded}
          />
        </div>
      </div>
    );
  }
}

export default BranchLoader;
